import { render, staticRenderFns } from "./mentScore.vue?vue&type=template&id=065ce1a7&scoped=true"
import script from "./mentScore.vue?vue&type=script&lang=js"
export * from "./mentScore.vue?vue&type=script&lang=js"
import style0 from "./mentScore.vue?vue&type=style&index=0&id=065ce1a7&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065ce1a7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('065ce1a7')) {
      api.createRecord('065ce1a7', component.options)
    } else {
      api.reload('065ce1a7', component.options)
    }
    module.hot.accept("./mentScore.vue?vue&type=template&id=065ce1a7&scoped=true", function () {
      api.rerender('065ce1a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hr/assess/config/mentScore.vue"
export default component.exports